import { useState } from "react";
import { useTranslation } from "react-i18next";
import { StripeCardElement } from "@stripe/stripe-js";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";

const useStripePaymentMethod = () => {
  // stripe hooks
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useTranslation("stripe");

  const createPaymentMethod = async () => {
    if (stripe && elements) {
      // Stripe.js has loaded
      // Make sure to disable form submission until Stripe.js has loaded.
      try {
        setLoading(true);
        // Get a reference to a mounted CardElement. Elements knows how
        // to find your CardElement because there can only ever be one of
        // each type of element.
        const cardElement = elements.getElement(CardElement);
        const { error, paymentMethod: stripePm } =
          await stripe.createPaymentMethod({
            type: "card",
            card: cardElement as StripeCardElement,
          });

        if (error) {
          // error
          throw t("Stripe could not process your card's info");
        } else if (stripePm) {
          const paymentMethod = {
            id: stripePm.id,
            brand: stripePm.card?.brand,
            last4: stripePm.card?.last4,
            default: true, // TODO: Revisit this if need auto set newly added card as default
          };

          return paymentMethod;
        }
      } finally {
        setLoading(false);
      }
    }
    return undefined;
  };

  return {
    createPaymentMethod,
    loading,
  };
};

export default useStripePaymentMethod;
